export const ChefsInfo = [
	{
		id: 1,
		name: "Gordon Ramsay",
		liveIn: "New York",
		photoId: 5,
		intro:
			"In ut odio libero, at vulputate urna. Nulla tristique mi a massa convallis cursus. Nulla eu mi magna. Etiam suscipit   gravida. ",
	},
	{
		id: 2,
		name: "Austin Evon",
		liveIn: "Florida",
		photoId: 2,
		intro:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
	},
	{
		id: 3,
		name: "Taylor Roberts",
		liveIn: "Miami",
		photoId: 3,
		intro:
			"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
	},
];
